export function parseStorageValue(value) {
  switch (value) {
    case "undefined":
      return undefined
    case "true":
      return true
    case "false":
      return false
    default:
      return undefined
  }
}